
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

class Categoria extends Component {

    state = {
        resource: [],
        response: [],
        optionsTipoRecurso: [],
        error: []
      }


    render() {
        return (
            (this.state.response.statusCode==200)?
            (
                <div id="detailBody" className="Site-content" >
                    <div className="loader"></div> 
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div id="Body" className="body-container container-fluid">
                            <div className="content-option" >
                                <div className="row recursos__search section__margin-bottom">
                                    <div className="col-sm-8">
                                        <div className="ibox-content">
                                                <div className="search-form">
                                                        <div className="input-group">
                                                            <i className="recursos__search-icon fas fa-search"></i>
                                                            <input type="text" placeholder="NOMBRE DEL RECURSO" name="search" className="recursos__search-form-control form-control input-lg" />
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-primary btn-primary__submit" type="submit">BUSCAR</button>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                        <thead>
                                                            <tr>
                                                                <th className="table-bordered-radius--left">CÓDIGO</th>
                                                                <th>DESCRIPCION</th>
                                                                <th>ETIQUETA</th>
                                                                <th className="text-center">ACTIVO</th>
                                                                <th className="table-bordered-radius--right text-center">ACCIÓN</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.resource.map((resource) => (
                                                            <tr key={resource.nCategoriaCodigo}>
                                                                <td>{resource.nCategoriaCodigo}</td>
                                                                <td>{resource.sDescripcion}</td>
                                                                <td>{resource.sEtiqueta}</td>
                                                                <td className="text-center">
                                                                    {(resource.bActivo?<span className="label label-info">ACTIVO</span>:<span class="label label-warning">INACTIVO</span>)}
                                                                </td>
                                                                <td className="recursos__table-action-option">
                                                                    <button primary="true" onClick={() => this.editResource(resource.nRecursoCodigo)} >
                                                                        <i className="fas fa-pen"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
            :
            (
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
            )
        );
    }

    editResource(id){

        this.props.history.push({
            pathname: '/recursoManager/' + id,
            state: { key: id }
          });
    }

    componentDidMount(){
        const url = `${API_URL}CategoryUX/`;
        
            axios.get(url).then(response => response.data)
            .then((data) => {
                console.log(data);
                this.setState({ resource: data.result, response: data, error: data.Error });
                document.querySelector('.loader').classList.add('loader--hide');
                document.getElementById('content-wrapper').removeAttribute("hidden");
            })
            .catch(error => {
                document.querySelector('.loader').classList.add('loader--hide');
                alert('Error de comunicación');
            });        
    }
}

export default Categoria;
